/*
 *
 * Footer
 *
 */

import React from "react";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import { Row, Col } from "antd";
import { DateTime } from "luxon";
import logo from "assets/images/logos/fertiberia-tech-white.png";
import { translate } from "utils/utils";
import Strings from "utils/strings";

import "./styles.scss";

type Location = "others" | "pt" | "es" | "fr" | "gr";
interface SocialLinks {
	label: string;
	link: Record<Location, string>;
}

export class Footer extends React.PureComponent<any, any> {
	renderSocialMedia() {
		const { location } = this.props;

		const socialLinks: Record<string, SocialLinks> = {
			facebook: {
				label: "Facebook",
				link: {
					others: "",
					pt: "https://www.facebook.com/adpfertilizantes.pt/",
					es: "https://www.facebook.com/FertiberiaTECHES",
					fr: "https://www.facebook.com/profile.php?id=61550834521376",
					gr: "",
				},
			},
			instagram: {
				label: "Instagram",
				link: {
					others: "https://www.instagram.com/fertiberia/",
					pt: "https://www.instagram.com/adpfertilizantes/",
					es: "https://www.instagram.com/fertiberia.tech/",
					fr: "",
					gr: "",
				},
			},
			youtube: {
				label: "Youtube",
				link: {
					others: "https://www.youtube.com/@grupofertiberia8274",
					pt: "https://www.youtube.com/@adpfertilizantes7144",
					es: "https://www.youtube.com/@fertiberiatech8288",
					fr: "https://www.youtube.com/@fertiberiafrance5225",
					gr: "",
				},
			},
			linkedin: {
				label: "Linkedin",
				link: {
					others: "https://www.linkedin.com/company/fertiberia-s-a",
					pt: "https://www.linkedin.com/company/adp-fertilizantes",
					es: "https://www.linkedin.com/company/fertiberia-tech-es",
					fr: "https://www.linkedin.com/company/fertiberia-france",
					gr: "",
				},
			},
		};

		const socialLinksKeys = Object.keys(socialLinks);

		if (socialLinksKeys.every((key) => socialLinks[key].link[location as Location] === "")) return null;

		return (
			<div className="Footer_Menu">
				<span className="Footer_Menu_Title">{Strings.footer.social}</span>
				{socialLinksKeys.map((key) => {
					if (socialLinks[key].link[location as Location] === "") return null;

					return (
						<a
							key={key}
							href={socialLinks[key].link[location as Location]}
							className="Footer_Menu_Item"
							target="_blank"
							rel="noopener noreferrer"
						>
							{socialLinks[key].label}
						</a>
					);
				})}
			</div>
		);
	}

	render() {
		const { dispatch, pages } = this.props;

		const year = DateTime.utc().toFormat("yyyy");

		return (
			<footer className="Footer_Container">
				<div className="Footer">
					<Row gutter={[50, 50]}>
						<Col xs={24} lg={5}>
							<div className="Footer_Logo">
								<img src={logo} alt="Footer Logo" />
							</div>
						</Col>

						{pages ? (
							<Col xs={12} md={8} lg={6}>
								<div className="Footer_Menu">
									<span className="Footer_Menu_Title">{Strings.footer.about}</span>
									{pages.map((page: any) => (
										<a
											key={page.type}
											href={`/page/${page.type}`}
											onClick={(e: any) => {
												e.preventDefault();
												dispatch(push(`/page/${page.type}`));
											}}
											className="Footer_Menu_Item"
										>
											{translate(page.title)}
										</a>
									))}
									<a
										href="/contact"
										onClick={(e: any) => {
											e.preventDefault();
											dispatch(push("/contact"));
										}}
										className="Footer_Menu_Item"
									>
										{Strings.footer.sendUsEmail}
									</a>
								</div>
							</Col>
						) : null}
						<Col xs={12} md={8} lg={6}>
							<div className="Footer_Menu">
								<span className="Footer_Menu_Title">{Strings.footer.services}</span>
								<a
									href="/deficiencies-identifying"
									onClick={(e: any) => {
										e.preventDefault();
										dispatch(push("/deficiencies-identifying"));
									}}
									className="Footer_Menu_Item"
								>
									{Strings.sidebar.deficiencyIdentification}
								</a>
								<a
									href="/agronomic-services"
									onClick={(e: any) => {
										e.preventDefault();
										dispatch(push("/agronomic-services"));
									}}
									className="Footer_Menu_Item"
								>
									{Strings.sidebar.agronomicServices}
								</a>
							</div>
						</Col>
						<Col xs={12} md={8} lg={6}>
							{this.renderSocialMedia()}
						</Col>
						<Col xs={24}>
							<div style={{ padding: 0 }}>
								<div className="Footer_Menu __alignRight" style={{ alignItems: "center" }}>
									<span className="Footer_Menu_Item">
										{`${Strings.footer.copyright}${year} ${Strings.footer.fertiberiaTech}`}
									</span>
								</div>
							</div>
						</Col>
					</Row>
				</div>
			</footer>
		);
	}
}

const mapStateToProps = (state: any) => ({
	router: state.router,
	location: state.location,
});

export default connect(mapStateToProps)(Footer);
